import { API_CONFIG } from '@/constants/config';
import { showToast } from '@/utils/toast/toast';

async function apiClient(endPoint, options = {}, doShowToast = true) {
    const serviceBaseUrl = API_CONFIG.BASE_URL + endPoint;

    try {
        const response = await fetch(serviceBaseUrl, {
            headers: {
                ...API_CONFIG.DEFAULT_HEADERS,
                ...(options.headers || {}),
            },
            ...options,
        });

        const data = await response.json().catch(() => null);

        if (!response.ok) {
            const error = new Error(
                data?.error || response.statusText || 'API Error'
            );
            error.status = response.status;
            error.data = data;
            throw error;
        }

        return { status: response.status, ...data };
    } catch (err) {
        console.error('Error in apiClient:', {
            serviceBaseUrl,
            method: options.method || 'GET',
            message: err.message,
            status: err.status,
            stack: err.stack,
        });
        // Show a toast notification for failed operations
        if (doShowToast) {
            showToast(
                'Operation could not be completed successfully',
                'error',
                5000
            );
        }

        throw err;
    }
}

export default apiClient;
